import React, { useState } from "react";
import { Link } from "react-router-dom"; // Import Link from react-router-dom
import Homepage_Data from "../../../utils/HomepageData";
import Button from "../../../components/Button";
import { openInNewTab } from "../../../utils/util";
import { pushToDataLayer } from "../../../utils/gtm";

export default function GetMoreValue() {
  const { getMoreValue } = Homepage_Data;
  const [visibleCards, setVisibleCards] = useState(3);

  const handleViewMore = (event) => {
    event.preventDefault();
    event.stopPropagation();
    pushToDataLayer("cta_clicked", { cta_name: "View All Comparision" });
    setVisibleCards((prev) => prev + 3);
  };

  const handleRoute = (slug) => {
    pushToDataLayer("service_comparison_viewed", {
      provider_name: slug,
    });
    openInNewTab(`/comparison/${slug}`);
  };

  return (
    <div className="mx-[20px] mt-[50px] lg:mx-[80px] lg:mt-[100px]">
      {/* Heading */}
      <h2 className="text-[24px] font-bold text-[#2C2C2C] mb-[15px] lg:text-[40px] lg:mb-[25px] sm:text-center">
        {getMoreValue.heading}
      </h2>
      <div className="sm:flex sm:justify-center">
        {/* Description */}
        <p className="text-[14px] font-[600] text-[#888888] lg:text-[20px] lg:max-w-[1200px] sm:text-center">
          {getMoreValue.text}
        </p>
      </div>
      <div className="flex flex-col gap-2 font-semibold mt-2 md:justify-center items-start md:items-center text-[#888888] my-4 text-xs md:text-sm">
        {getMoreValue.bullets?.map((item) => (
          <div className="flex">
            <p>{item}</p>
          </div>
        ))}
      </div>
      <div className="sm:flex sm:justify-center mt-2">
        {/* Description */}
        <p className="text-[14px] font-[600] text-[#888888] lg:text-[20px] lg:max-w-[1200px] sm:text-center">
          {getMoreValue.text2}
        </p>
      </div>
      {/* Card Details */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-[30px] mt-[20px]">
        {getMoreValue.cardDetails.slice(0, visibleCards).map((item, index) => (
          <Link
            key={index}
            // Dynamic link based on the card's ID
            onClick={() => handleRoute(item?.slug)}
            className="flex bg-[#FFFFFF] py-[10px] justify-around items-center mx-auto max-w-[400px] lg:max-w-[500px] lg:py-[40px] cursor-pointer hover:shadow-xl transition-shadow duration-300"
          >
            {/* Left Box */}
            <div className="relative left-[25px] sm:left-[50px] lg:left-[50px] 2xl:left-[65px] sm:w-[350px] lg:w-[45%]">
              <div className="relative">
                <img
                  src={getMoreValue.leftBox}
                  alt="left-Box"
                  className="w-full"
                />
              </div>
              <img
                className="absolute bottom-[25%] left-[12%] w-[70px] h-[70px] lg:left-[15%]"
                src={item.first_exchange_img}
                alt="First-Exchange"
              />
            </div>

            {/* VS Box */}
            <div className="z-[9999] absolute lg:relative">
              <img className="w-[70px]" src={getMoreValue.vsBox} alt="VS-Box" />
            </div>

            {/* Right Box */}
            <div className="relative right-[25px] sm:right-[50px] lg:right-[50px] 2xl:right-[65px] sm:w-[350px] lg:w-[45%]">
              <div className="relative">
                <img
                  src={getMoreValue.rightBox}
                  alt="Right-Box"
                  className="w-full"
                />
              </div>
              <img
                className="absolute right-[12%] w-[70px] h-[70px]  bottom-[25%] lg:right-[15%]"
                src={item.second_exchange_img}
                alt="Second-Exchange"
              />
            </div>
          </Link>
        ))}
      </div>

      {/* View More Button */}
      {visibleCards < getMoreValue.cardDetails.length && (
        <div className="flex justify-center my-[30px] sm:mb-[50px]">
          {/* <Button
            btnText="View All Comparisons"
            onClick={handleViewMore}
            classes="bg-[#7B3BCC] h-[28px] w-auto px-[10px] w-[115px] !rounded-sm text-[10px] font-[600] text-[#FFFFFF] sm:h-auto sm:w-auto sm:text-[16px] sm:px-[20px] sm:py-[10px]"
            type="button"
          /> */}
          <Button
            btnText="View All Comparisons"
            onClick={handleViewMore}
            classes="bg-white border-2 border-[#6C33B5] text-[12px] text-[#000000] rounded-md mx-auto mt-[20px] px-[20px] py-[5px] lg:text-[20px] lg:px-[30px] lg:py-[10px] lg:hover:bg-[#6C33B5] lg:hover:text-white transition-colors duration-300"
          />
        </div>
      )}
    </div>
  );
}
